import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Login from './pages/Login';
import SellerDomesticHvi from './pages/SellerDomesticHvi';
import SellerHVIDetailsForm from './pages/SellerHVIDetailsForm'; // Import the new HVI details form
import SellerDomesticDescription from './pages/SellerDomesticDescription';
import SellerImportDescription from './pages/SellerImportDescription';
import SellerImportRecap from './pages/SellerImportRecap';
import BuyerDomesticHvi from './pages/BuyerDomesticHvi';
import BuyerDomesticDescription from './pages/BuyerDomesticDescription';
import BuyerImportDescription from './pages/BuyerImportDescription';
import BuyerImportRecap from './pages/BuyerImportRecap';
import BuyerInquiryCotton from './pages/BuyerInquiryCotton';
import MMF from './pages/MMF';
import YARN from './pages/YARN';
import PrivateRoute from './components/PrivateRoute';
import Confirmation from './pages/Confirmation'; // Keep Confirmation
import AuthCallback from './pages/AuthCallback';
import LandingPage from './pages/LandingPage';
import RoleDetails from './pages/RoleDetails';
import SellerPrimaryDetails from './pages/SellerPrimaryDetails';
import BuyerMarket from './pages/BuyerMarket';
import RoleSelection from './pages/RoleSelection';
import BuyerDashboard from './pages/BuyerDashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/home" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login />} />
          <Route path="/role-selection" element={<PrivateRoute><RoleSelection /></PrivateRoute>} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Seller Side Routes */}
          <Route path="/seller/domestic-hvi" element={<PrivateRoute><SellerDomesticHvi /></PrivateRoute>} />
          <Route path="/seller/domestic-hvi/details" element={<PrivateRoute><SellerHVIDetailsForm /></PrivateRoute>} />
          <Route path="/seller/domestic-description" element={<PrivateRoute><SellerDomesticDescription /></PrivateRoute>} />
          <Route path="/seller/import-description" element={<PrivateRoute><SellerImportDescription /></PrivateRoute>} />
          <Route path="/seller/import-recap" element={<PrivateRoute><SellerImportRecap /></PrivateRoute>} />

          {/* Buyer Side Routes */}
          <Route path="/buyer/dashboard" element={<PrivateRoute><BuyerDashboard /></PrivateRoute>} />
          <Route path="/buyer/domestic-hvi" element={<PrivateRoute><BuyerDomesticHvi /></PrivateRoute>} />
          <Route path="/buyer/domestic-description" element={<PrivateRoute><BuyerDomesticDescription /></PrivateRoute>} />
          <Route path="/buyer/import-description" element={<PrivateRoute><BuyerImportDescription /></PrivateRoute>} />
          <Route path="/buyer/import-recap" element={<PrivateRoute><BuyerImportRecap /></PrivateRoute>} />
          <Route path="/buyer/inquiry-cotton" element={<PrivateRoute><BuyerInquiryCotton /></PrivateRoute>} />

          {/* MMF and YARN Routes */}
          <Route path="/mmf" element={<PrivateRoute><MMF /></PrivateRoute>} />
          <Route path="/yarn" element={<PrivateRoute><YARN /></PrivateRoute>} />

          {/* Existing routes, ensure proper order */}
          <Route path="/confirmation" element={<PrivateRoute><Confirmation /></PrivateRoute>} />
          <Route path="/role" element={<PrivateRoute><RoleDetails /></PrivateRoute>} />
          <Route path="/seller/primary" element={<PrivateRoute allowedRoles={['seller']}><SellerPrimaryDetails /></PrivateRoute>} />
          <Route path="/buyer" element={<PrivateRoute allowedRoles={['buyer']}><BuyerMarket /></PrivateRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

